/**
 * Encodes a string to URL-safe Base64 for use in URL path segments.
 * This avoids all IIS issues with special characters like @, ., etc.
 * 
 * @param {string} str - The string to encode (typically an email address)
 * @returns {string} - URL-safe Base64 encoded string
 */
export const encodeUrlParam = (str) => {
  if (!str) return "";
  try {
    // Convert to Base64, then make URL-safe (replace +, /, remove =)
    const base64 = btoa(unescape(encodeURIComponent(str)));
    return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  } catch (e) {
    // Fallback to simple encoding if btoa fails
    return encodeURIComponent(str);
  }
};

/**
 * Decodes a URL-safe Base64 encoded string back to original.
 * Use this in components that receive the encoded parameter.
 * 
 * @param {string} str - The encoded string
 * @returns {string} - Decoded original string
 */
export const decodeUrlParam = (str) => {
  if (!str) return "";
  try {
    // Restore standard Base64 characters and padding
    let base64 = str.replace(/-/g, '+').replace(/_/g, '/');
    // Add padding if needed
    while (base64.length % 4) base64 += '=';
    return decodeURIComponent(escape(atob(base64)));
  } catch (e) {
    // If decoding fails, return as-is (might be plain text)
    return str;
  }
};
